import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'om-skaden';
            break;
        case 'om-skaden':
            nextPage = 'andre-personer';
            break;
        case 'andre-personer':
            if (getValueOrDefault(formConfig, formValues, 'thirdPartyInvolved').value === 'y') {
                nextPage = 'om-personen';
            } else {
                nextPage = 'beskriv-skaden';
            }
            break;
        case 'om-personen':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'genstandsregistrering';
            break;
        case 'genstandsregistrering':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;
        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
